import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Card, Typography } from '@otp/ui';
import { Routes } from 'src/components/common/router/constants';
import styles from '../index.module.css';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';

export const QuickLinks = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const quickLinks = [
    {
      title: t('my-organisation.quick-links.community-app'),
      route: 'https://app.joinblink.com/#/home',
    },
    {
      title: t('my-organisation.quick-links.otp-training-path'),
      route: Routes.lmsCurriculums.path,
    },
    {
      title: t('my-organisation.quick-links.learning-path'),
      route:
        'https://truegroup-my.sharepoint.com/:b:/g/personal/evan_blust_truegroup_net/EV3DNuKPcyxPr82xm1Re3r0BsdXee36pS1ycJVHpP5KG6w?e=fSA5xp%22',
    },
  ];

  return (
    <Grid container spacing={2}>
      {quickLinks.map((link) => (
        <Grid item xs={12} key={link.title}>
          <Card
            padding={2}
            className="bg-[#F8F9FD] border-none flex group hover:bg-[#F8B92A] hover:border-none transition-colors w-full h-10 rounded-lg"
            isLink
            onClick={() => navigate(link.route)}
            linkIconClassName={clsx(
              styles.linkIconCustom,
              'absolute top-1/2 right-2 transform -translate-y-1/2 transition-colors',
            )}
          >
            <Grid container alignItems="center" className="pr-10">
              <Grid item>
                <Typography
                  variant="subtitle1"
                  fontSize={14}
                  fontFamily="Inter"
                >
                  {link.title}
                </Typography>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default QuickLinks;
